
import WOW from "../../public/statics/ll/js/wow";


import $ from "jquery";

import Vue, { onMounted } from "vue";
import {
  ref,
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
} from "vue";
import {} from "../views/api/user";

export default defineComponent({
  components: {

  },
  data() {
    return {};
  },

  setup() {
 // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;


      let show = ref<any>(false);
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };

   let proxy = getCurrentInstance() as any;

    //全局语言
    if (window.sessionStorage.getItem("language") as string) {
      var lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
    }
if(lan=="EN"){
show.value=false
}else{
  show.value=true
}
    // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;





  

    //判断浏览器的屏幕
    function redirectPage() {
      var wjb51 = screen.width;

      if (wjb51 <= 450) {
        $(".center-title").removeClass("wow slideInUp");
        $(".center-top-content-left").removeClass(
          "wow bounceInLeft bg-green  animated"
        );
        $(".center-top-content-right").removeClass(
          "wow bounceInRight bg-yellow  animated"
        );
        $(".center-btn-t").removeClass("wow swing bg-purple animated");
        $(".center-bot-content-left").removeClass(
          "wow bounceInDown bg-green  animated"
        );
        $(".center-bot-content-middle2 h4").removeClass(
          "wow bounceInLeft bg-green  animated"
        );
        $(".center-bot-content-middle-p").removeClass(
          "wow bounceInLeft bg-green   animated"
        );
        $(".center-bot-content-middle3").removeClass(
          "wow lightSpeedIn bg-purple  animated"
        );
      }
    }

    onMounted(() => {
      //卡片
      $(function () {
        var sumgs = $(".v_cont ul li>div").length; //div的总个数
        var sum = 0; //总页数
        var jdtlen; //进度条点击之后的长度
        var djlen = 1; //数字
        $(".slider-nav-page").text("0" + djlen);
        sum = String(sumgs / 4).indexOf(".") + 1; //获取小数点的位置
        var count = String(sumgs / 4).length - sum; //获取小数点后的个数
        if (sum > 0) {
          //判断是否有小数
          sum++;
        } else {
          sum = sumgs / 4;
          jdtlen = 160 / sum;
        }
        $(".slider-nav-total").text("0" + sum);
        var gblen = djlen;
        $(".slider-progress-inner").animate(
          {
            width: 160 / sum + "px",
          },
          1000
        );
        $(".slider-nav-item-next").click(function () {
          if (gblen == sum) {
            gblen = 1;
            // $(".slider-nav-page").text("0" + gblen);
          } else {
            ++gblen;
            // $(".slider-nav-page").text("0" + gblen);
          }
          $(".slider-progress-inner").animate(
            {
              width: (160 / sum) * gblen + "px",
            },
            1000
          );
        });
        $(".slider-nav-item-prev").click(function () {
          if (gblen <= 1) {
            gblen = sum;
            // $(".slider-nav-page").text("0" + gblen);
          } else {
            --gblen;
            // $(".slider-nav-page").text("0" + gblen);
          }
          $(".slider-progress-inner").animate(
            {
              width: (160 / sum) * gblen + "px",
            },
            1000
          );
        });
      });

      WOW.init();
      //切换
      $(function () {
        /*======next======*/
        $(".next").click(function () {
          nextscroll();
        });

        function nextscroll() {
          var vcon = $(".v_cont ");
          var offset = $(".v_cont li").width() * -1;
          vcon.stop().animate(
            {
              left: offset,
            },
            "slow",
            function () {
              var firstItem = $(".v_cont ul li").first();
              vcon.find("ul").append(firstItem);
              $("ul").css("left", "0px");
              circle();
            }
          );
        }

        function circle() {
          var currentItem = $(".v_cont ul li").first();
          var currentIndex = currentItem.attr("index");
          $(".circle li").removeClass("circle-cur");
          $(".circle li").eq(currentIndex).addClass("circle-cur");
        }

        //setInterval(nextscroll,2000)

        /*======prev======*/

        $(".prev").click(function () {
          var vcon = $(".v_cont ");
          var offset = $(".v_cont li").width() * -1;
          var lastItem = $(".v_cont ul li").last();
          vcon.find("ul").prepend(lastItem);
          vcon.css("left", offset);
          vcon.animate(
            {
              left: "0px",
            },
            "slow",
            function () {
              circle();
            }
          );
        });

        /*======btn====circle======*/

        var animateEnd = 1;
        $(".circle li").click(function () {
          if (animateEnd == 0) {
            return;
          }
          $(".circle li")
            .addClass("circle-cur")
            .siblings()
            .removeClass("circle-cur");
          var nextindex = $(".circle li").index();
          var currentindex = $(".v_cont li").first().attr("index");
          var curr = $(".v_cont li").first().clone();
          if (nextindex > currentindex) {
            for (var i = 0; i < nextindex - currentindex; i++) {
              var firstItem = $(".v_cont li").first();
              $(".v_cont ul").append(firstItem);
            }
            $(".v_cont ul").prepend(curr);
            var offset = $(".v_cont li").width() * -1;
            if (animateEnd == 1) {
              animateEnd = 0;
              $(".v_cont")
                .stop()
                .animate(
                  {
                    left: offset,
                  },
                  "slow",
                  function () {
                    $(".v_cont ul li").first().remove();
                    $(".v_cont").css("left", "0px");
                    animateEnd = 1;
                  }
                );
            }
          } else {
            var curt = $(".v_cont li").last().clone();
            for (var ii = 0; ii < currentindex - nextindex; ii++) {
              var lastItem = $(".v_cont li").last();
              $(".v_cont ul").prepend(lastItem);
            }
            $(".v_cont ul").append(curt);
            var offset1 = $(".v_cont li").width() * -1;
            $(".v_cont").css("left", offset1);
            if (animateEnd == 1) {
              animateEnd = 0;
              $(".v_cont")
                .stop()
                .animate(
                  {
                    left: "0px",
                  },
                  "slow",
                  function () {
                    $(".v_cont ul li").last().remove();
                    animateEnd = 1;
                  }
                );
            }
          }
        });
      });

      redirectPage();
    });
    // const handleRegister = async () => {
    //   const loginParams = {
    //     username: state.Account,
    //     password: state.Password,
    //   }
    //   const res = await UserService.resgister(loginParams)
    //   console.log(res)
    // }
    return {
      onSwiper,
      onSlideChange,
      show,
      //   modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
});
